import { FormBase } from 'core/components';

export default class ReturnLabelForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}

	setup() {
		return {
			fields: [
				{
					name: 'address1',
					label: 'ORDERVIEW.RETURNLABELVIEW.ADDRESS.ADDRESS1',
					rules: 'required|string',
				},
				{
					name: 'address2',
					label: 'ORDERVIEW.RETURNLABELVIEW.ADDRESS.ADDRESS2',
				},
				{
					name: 'address3',
					label: 'ORDERVIEW.RETURNLABELVIEW.ADDRESS.ADDRESS3',
				},
				{
					name: 'city',
					label: 'ORDERVIEW.RETURNLABELVIEW.ADDRESS.CITY',
					rules: 'required|string',
				},
				{
					name: 'zipCode',
					label: 'ORDERVIEW.RETURNLABELVIEW.ADDRESS.ZIPCODE',
					rules: 'required',
				},
				{
					name: 'countryStateCode',
					label: 'ORDERVIEW.RETURNLABELVIEW.ADDRESS.COUNTRYSTATECODE',
					rules: 'required',
				},
				{
					name: 'countryCode',
					label: 'ORDERVIEW.RETURNLABELVIEW.ADDRESS.COUNTRYCODE',
					rules: 'required',
				},
				{
					name: 'buyerName',
					label: 'ORDERVIEW.RETURNLABELVIEW.CONTACT.BUYERNAME',
					rules: 'required',
				},
				{
					name: 'phone1',
					label: 'ORDERVIEW.RETURNLABELVIEW.CONTACT.PHONE1',
					rules: 'required',
				},
				{
					name: 'carrierServiceId',
					label: 'ORDERVIEW.RETURNLABELVIEW.CARRIERSERVICE',
					rules: 'required',
				},
				{
					name: 'internalNote',
					label: 'ORDERVIEW.RETURNLABELVIEW.INTERNALNOTE',
				},
				{
					name: 'returnAddressId',
					label: 'ORDERVIEW.RETURNLABELVIEW.RETURNADDRESS',
					rules: 'required',
				},
				{
					name: 'returnReasonId',
					label: 'ORDERVIEW.RETURNLABELVIEW.RETURNREASON',
					rules: 'required',
				},
			],
		};
	}
}
